document.addEventListener('DOMContentLoaded', function (e) {
  const headerMiddle = document.querySelector('.m-header__bottom');
  const stickyNavElement = document.querySelector('.m-header__top');
  let stickyNavOptions = {
    rootMargin: '0px 0px 0px 0px',
    threshold: 1,
  };

  if (document.body.classList.contains('user-logged-in')) {
    stickyNavOptions.rootMargin = '0px 0px 81px 0px';
  }

  const stickyNavCallback = function (entries, observer) {
    entries.forEach(entry => {
      if (!entry.isIntersecting && entry.boundingClientRect.x > 0) {
        stickyNavElement.classList.add('sticky');
      } else {
        stickyNavElement.classList.remove('sticky');
      }
    });
  };
  
  let stickyNavObserver = new IntersectionObserver(stickyNavCallback, stickyNavOptions);

  if (headerMiddle) {
    stickyNavObserver.observe(headerMiddle);
  }
});